import React ,{ useEffect, useState } from 'react';
import './css/footer.css';
import background from '../assets/images/FooterBackground.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';



const Footer = () => {
  const [isVisible, setIsVisible] = useState(false); // Initialize visibility state for offers


  useEffect(() => {
      const handleScroll = () => {
          if (window.scrollY > 2200) {
              setIsVisible(true);
          }
   
      };

      window.addEventListener('scroll', handleScroll);

      return () => {
          window.removeEventListener('scroll', handleScroll);
      };
  }, []);



  return (
    <div className="footerbody">
      <div className="imageContainer">
        <img src={background} alt="Bolagala Nature Resort" className="backgroundImage" />
      </div>
      <div className="scrollContent">
        <div className="content" style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(150px)',
                transition: 'opacity 0.5s ease-in-out, transform 2s ease-in-out',
                visibility: isVisible ? 'visible' : 'hidden'
            }}>

          <div className='aboutus'>
            <h1>About Us</h1>
            <p>
              Bolagala Nature Resort is a luxury resort located in the heart of Katana, Sri Lanka.
              The resort is surrounded by lush greenery and offers a peaceful and serene environment for
              guests to relax and unwind. With a range of accommodation options, wellness facilities, and
              outdoor activities, Bolagala Nature Resort is the perfect destination for a relaxing getaway.
            </p><br></br>
            <div className='socialLinks'>
              <a href="https://www.facebook.com/profile.php?id=61562127297093" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href="https://www.instagram.com/bolagalanatureresort/" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://www.youtube.com/@BolagalaNatureResort" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faYoutube} />
              </a>
              <a href="https://www.tiktok.com/@bolagalanatureresort?is_from_webapp=1&sender_device=pc" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faTiktok} />
              </a>
            </div>
          </div>


          <div className='quickLinks'>
            <h1>Quick Links</h1>
              <p><a href="#Accommodation">Accommodation</a></p>
              <p><a href="#DayOut">Day Out</a></p>
              <p><a href="#Wellness">Wellness</a></p>
              <p><a href="#Activities">Activities</a></p>
              <p><a href="#Gallery">Gallery</a></p>
              <p><a href="#Contact">Contact</a></p>
          </div>

          <div className='contact'>
            <h1>Contact Us</h1>         
            <h3><FaMapMarkerAlt style={{ marginRight: '8px'}} />Address</h3>
              <p>
                No: 60/3, Otharawadiya, <br />
                Katana, Sri Lanka
              </p>

            <h3><FaPhoneAlt style={{ marginRight: '8px' }} />Phone</h3>
              <p><a href="tel:+94765325425">+94 76 532 5425</a></p>

            <h3><FaEnvelope style={{ marginRight: '8px' }} />Email</h3>
              <p>
                <a href="mailto:bolagalanatureresort@gmail.com">bolagalanatureresort@gmail.com</a>
              </p>
          </div>

        </div>
      </div>
      <div className='coppyright'>
      All copyrights reserved by Bolagala Nature Resort - © 2024
    </div>
    </div>
    
  );
};

export default Footer;
